import type { Answer, Quiz } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { findRecord, query } from '@warp-drive/utilities/json-api';

import { jsonApiOptions, page } from '../../json-api.ts';

export function findCoachingQuiz(quizId: string) {
  return findRecord<Quiz>(DataTypeQuiz.Quiz, quizId, jsonApiOptions);
}

export function queryCoachingQuizAnswer(userId: string, quizId: string) {
  return query<Answer>(
    DataTypeQuiz.Answer,
    {
      'filter[user]': userId,
      'filter[quiz.id]': quizId,
      ...page({ offset: 0, limit: 1 }),
    },
    jsonApiOptions
  );
}
